export default {
  "code": "nl",
  "title": "Nederlands",
  "flag": "🇳🇱",
  "meta": {
    "index": {
      "title": "Betere onderzoekspapers.\n10x sneller met AI.",
      "description": "Zonder Hesse: Je staart uren naar een lege pagina.\nMet Hesse: Je genereert uitstekende teksten met één klik."
    },
    "profile": {
      "title": "Profielinstellingen",
      "description": "Beheer eenvoudig je profielinstellingen"
    }
  },
  "templates": {
    "summarize-text": {
      "headline": "",
      "description": ""
    },
    "find-topic": {
      "headline": "Onderwerp vinden",
      "description": "Brainstorming om meer ideeën te krijgen voor een onderzoekspaper onderwerp."
    },
    "find-sources": {
      "headline": "Bronnen vinden",
      "description": "Zoek naar academische bronnen die relevant kunnen zijn voor het onderwerp."
    },
    "source-qa": {
      "headline": "Bronnen-chat",
      "description": "Beantwoord vragen over een bron. Voeg een link toe naar een website, een online document, of upload een bestand van je computer."
    },
    "write-outline": {
      "headline": "Schema maken",
      "description": "Maak een ruwe schets voor een onderzoekspaper onderwerp."
    },
    "write-introduction": {
      "headline": "Inleiding schrijven",
      "description": "Maak een inleiding voor een onderzoekspaper."
    },
    "write-chapter": {
      "headline": "Hoofdstuk schrijven",
      "description": "Schrijf een hoofdstuk voor een onderzoekspaper."
    },
    "write-essay": {
      "headline": "Essay schrijven",
      "description": "Schrijf een complete onderzoekspaper."
    },
    "proofreading": {
      "headline": "Proeflezen",
      "description": "Corrigeer een tekst."
    },
    "freestyle": {
      "headline": "Freestyle",
      "description": "Schrijf een willekeurige tekst."
    },
    "summarize-document": {
      "headline": "",
      "description": ""
    },
    "summarize-article": {
      "headline": "",
      "description": ""
    },
    "summarize-source": {
      "headline": "",
      "description": ""
    }
  },
  "validations": {
    "required": "{_field_} is een verplicht veld",
    "min": "{_field_} moet minimaal {length} tekens bevatten",
    "max": "{_field_} mag niet langer zijn dan {length} tekens"
  },
  "buttons": {
    "close": "Sluiten",
    "upgrade": "upgraden",
    "get_more_words": "Nu meer woorden krijgen",
    "login": "inloggen",
    "logout": "uitloggen",
    "cancel": "Annuleren",
    "yes": "Ja",
    "no": "Nee",
    "tryout": "uitproberen",
    "add": "toevoegen",
    "report": "rapporteren",
    "save": "opslaan",
    "edit": "bewerken",
    "copy": "kopiëren",
    "delete": "verwijderen",
    "generate": "genereren",
    "signup": "registreren",
    "continue": "doorgaan",
    "submit": "versturen",
    "add_source": "Bron toevoegen",
    "select_source": "Bron selecteren",
    "new_document": "Nieuw Document",
    "back": "terug",
    "local_document": {
      "title": "PDF-document van mijn computer",
      "type": "PDF-document uploaden"
    },
    "web_document": {
      "title": "Weblink, bijvoorbeeld Wikipedia",
      "type": "Weblink toevoegen"
    },
    "done": "klaar",
    "discard": "verwerpen",
    "ask": "Vraag",
    "flag": "Markeren"
  },
  "labels": {
    "missing_subscription": "Je hebt een abonnement nodig om dit hulpmiddel te gebruiken.",
    "booked": "je huidige plan",
    "account": "Account",
    "subscription": "Abonnement",
    "name": "Naam",
    "email": "E-mail",
    "limit": "Limiet",
    "settings": "Instellingen",
    "words": "Woorden",
    "usage": "Gebruik",
    "extra_words": "inclusief {words} extra woorden",
    "show_all_applications": "Alle applicaties tonen",
    "show_all": "Alles tonen",
    "start_page": "Ga naar startpagina",
    "is_favorite": "In favorieten",
    "add_favorite": "Toevoegen aan favorieten",
    "wordlimit_reached": "Woordlimiet bereikt",
    "wordlimit_increase": "Woordlimiet nu verhogen",
    "contact": "Contact openen",
    "history": "Geschiedenis",
    "show_history": "geschiedenis tonen",
    "inprint": "Impressum",
    "dataregulation": "Gegevensbescherming",
    "tos": "Algemene voorwaarden",
    "month": "maand",
    "cancel_anytime": "Op elk moment opzegbaar",
    "try_now": "nu gratis uitproberen",
    "book_again": "Opnieuw boeken",
    "book": "Plan wijzigen",
    "upgrade_to": "Upgraden naar {product}",
    "copied_link": "Link gekopieerd",
    "subject": "Onderwerp",
    "generated_by_hesse": "Gegenereerd door Hesse in 3 seconden.",
    "use_template": "sjabloon gebruiken",
    "show_mode": "meer tonen",
    "upload": "uploaden",
    "optional": "optioneel",
    "my_documents": "Mijn Documenten",
    "my_sources": "Mijn Bronnen",
    "add_source": "Bron toevoegen",
    "select_source": "Bron selecteren",
    "page": "Pagina {page}",
    "pages": "Pagina's {from} - {to}",
    "unknown_author": "Onbekende auteur",
    "checker_results": "AI-detector resultaten",
    "human": "menselijk",
    "citation_style": "Citeringsstijl",
    "started_at": "gestart op",
    "ends_at": "eindigt op",
    "cancel_subscription": "abonnement opzeggen",
    "file_too_large": "Bestand te groot (max. 50 MB), probeer het te splitsen",
    "relevance": "Relevantie",
    "relevance_help": "Relevantie meet hoe goed de bron past bij het gezochte onderwerp in termen van inhoud.",
    "quality": "Kwaliteit",
    "quality_help": "Kwaliteit meet hoe goed de bron is in zowel inhoud als vorm.",
    "trustworthiness": "Betrouwbaarheid",
    "trustworthiness_help": "Betrouwbaarheid meet, voornamelijk gebaseerd op de metadata van de bron, hoe betrouwbaar deze is.",
    "high": "hoog",
    "normal": "normaal",
    "low": "laag",
    "features": "Functies",
    "monthly": "Maandelijks",
    "year": "jaar",
    "yearly": "Jaarlijks",
    "save_50": "bespaar 50%",
    "pay_amount_per_period": "Betaal {amount}/{period}.",
    "focus_of_the_chapter": "Focus van het hoofdstuk",
    "reason": "Reden",
    "summary": "Samenvatting",
    "raw_text": "Ruwe tekst",
    "topic": "Onderwerp",
    "essay_banner_part_1": "🚨 <i>Deze functie wordt binnenkort uitgeschakeld</i><br/>Voor <strong>betere generatieresultaten</strong> en <strong>meer fijnmazige controle</strong>, raden we aan om het hulpmiddel te gebruiken",
    "essay_banner_part_2": "en je essay <strong>hoofdstuk voor hoofdstuk</strong> te genereren. Probeer het uit voor een vloeiendere, meer op maat gemaakte schrijfervaring! ✨📖",
    "language": "Taal",
    "language_english_hint": "Veel wetenschappelijke artikelen worden in het Engels gepubliceerd. We raden aan ook naar Engelse bronnen te zoeken om meer relevante resultaten te vinden.",
    "length": "Lengte",
    "length_options": [
      {
        "text": "kort (4 alinea's)",
        "value": "short"
      },
      {
        "text": "normaal (6 alinea's)",
        "value": "normal"
      },
      {
        "text": "lang (8 alinea's)",
        "value": "long"
      }
    ],
    "source_type_options": [
      {
        "label": "Automatische bronnenonderzoek",
        "value": "quality"
      },
      {
        "label": "Werk met je eigen bronnen",
        "value": "quality_with_sources"
      }
    ],
    "sources": "Bronnen",
    "source": "Bron",
    "open_access": "Open Access",
    "show_only_open_access": "Alleen vrij beschikbare bronnen tonen",
    "essay_outline_options": [
      {
        "value": "generate",
        "label": "Genereer een schema voor mij"
      },
      {
        "value": "provide",
        "label": "Gebruik mijn eigen schema"
      }
    ],
    "your_outline": "Je schema",
    "year_of_publication": "Publicatiejaar",
    "outline": "Schema",
    "summary_type": "Type samenvatting",
    "summary_type_options": [
      {
        "label": "Informatief",
        "value": "informative"
      },
      {
        "label": "Beschrijvend",
        "value": "descriptive"
      },
      {
        "label": "Kritisch",
        "value": "critical"
      },
      {
        "label": "Abstract",
        "value": "abstract"
      }
    ],
    "original_text": "Originele tekst",
    "maintenance": "Onze diensten zijn momenteel in onderhoud. Sorry voor het ongemak en bedankt voor je begrip!",
    "something_wrong": "Controleer altijd citaten. Er klopt iets niet?",
    "bad_citation_title": "Citaat rapporteren",
    "bad_citation_text": "Vertel ons wat je denkt dat er niet klopt aan het gemarkeerde citaat.",
    "thanks_for_report": "Bedankt dat je ons helpt Hesse AI beter te maken!",
    "no_sources_found": "Geen bronnen gevonden. Probeer je onderwerp of zoekfilters aan te passen.",
    "user_instruction": "Aangepaste instructies",
    "document": "Document",
    "article": "Artikel",
    "study_program": "Studieprogramma",
    "study_subject": "Vak",
    "interests": "Interesses",
    "used_for_source_search": "Gebruikt voor bronnenonderzoek",
    "not_used_for_source_search": "Niet gebruikt voor bronnenonderzoek",
    "headline": "Focus van het hoofdstuk",
    "chapter_length": "Lengte",
    "chapter_length_options": [
      {
        "text": "kort (4 alinea's)",
        "value": "short"
      },
      {
        "text": "normaal (6 alinea's)",
        "value": "normal"
      },
      {
        "text": "lang (8 alinea's)",
        "value": "long"
      }
    ],
    "source_chat_placeholder": "Vat deze bron voor mij samen...",
    "publish_year": "Publicatiejaar",
    "text": "Originele tekst",
    "prompt": "Instructie"
  },
  "blog": {
    "written_by": "Geschreven door",
    "read_article": "Artikel lezen"
  },
  "stages": {
    "searching_sources": "Bronnen zoeken",
    "filtering_sources": "Bronnen filteren",
    "processing_sources": "Bronnen verwerken",
    "writing_plan": "Schrijfplan maken",
    "writing_chapter": "Hoofdstuk schrijven"
  },
  "source": {
    "select": {
      "empty": {
        "headline": "Nog niets hier.",
        "hint": "Je kunt bronnen markeren in 'Bronnen vinden' en ze in verschillende hulpmiddelen gebruiken."
      }
    },
    "table": {
      "name": "Naam",
      "type": "Type",
      "created_at": "Gemaakt op"
    },
    "type": {
      "document": "Document",
      "website": "Artikel",
      "paper": "Artikel"
    },
    "snippet": {
      "hint": "De tekst uit het originele document kan vreemd geformatteerd zijn. In de meeste gevallen is dit geen probleem voor de AI. Maar we werken eraan om dit te verbeteren."
    },
    "hint": {
      "not_usable": "Bronnen die nog niet zijn verwerkt, worden niet meegenomen bij het schrijven."
    },
    "processing": "wordt verwerkt...",
    "recent": "recent gebruikt",
    "bookmark": "bladwijzer",
    "bookmarked": "gebladwijzerd",
    "direct_pdf_access": "Directe PDF-toegang",
    "source_info": "Broninformatie"
  },
  "placeholders": {
    "url": "https://www.nature.com/articles/s41586-023-06447-0",
    "topic": "Duurzame stedelijke ontwikkeling: Smart Cities tussen innovatie en sociale rechtvaardigheid",
    "focus_of_the_chapter_legacy": "Digitale transformatie",
    "focus_of_the_chapter": "Hoe zou je je hoofdstuk noemen?",
    "outline": "I. De evolutie van Smart Cities\n   A. Van traditionele naar verbonden steden\n      1. Definitie en kernconcepten\n      2. Technologische drijvers van ontwikkeling\n   B. Duurzaamheid als centraal paradigma\n      1. Milieumonitoring en -bescherming\n      2. Hulpbronoptimalisatie via IoT\nII. Sociale dimensies van digitalisering\n   A. Inclusie en toegankelijkheid\n   B. Burgerdatasobereiniteit\n   C. Digitale kloof overbruggen",
    "original_text": "Kwantumfysica revolutioneert ons begrip van de werkelijkheid op het meest fundamentele niveau.\nIn tegenstelling tot klassieke fysica, waar deeltjes ofwel deeltjes of golven zijn, toont kwantummechanica aan dat materie beide eigenschappen gelijktijdig kan hebben.\nHet beroemde dubbele-spleet experiment demonstreert deze dualiteit indrukwekkend: individuele fotonen creëren een interferentiepatroon alsof ze door beide spleten tegelijk gaan.\nKwantumverstrengeling, door Einstein beschreven als 'spookachtige actie op afstand', stelt deeltjes in staat om over grote afstanden instantaan verbonden te blijven.\nDeze verschijnselen vormen de basis voor revolutionaire technologieën zoals kwantumcomputers en kwantumcryptografie...",
    "chat": "Welke praktische toepassingen vloeien hieruit voort?",
    "report_citation": "Deze citatie is onnauwkeurig omdat...",
    "user_instruction": "Analyseer de impact van digitalisering op traditionele ambachtelijke beroepen en toon oplossingsbenaderingen",
    "topic_placeholder": "Kunstmatige intelligentie in het onderwijs: Kansen en uitdagingen",
    "outline_placeholder": "I. Inleiding tot AI-ondersteund onderwijs\n   A. Definitie en fundamenten\n      1. Wat is AI in educatieve context?\n      2. Huidige ontwikkelingen en trends\n   B. Potentieel voor gepersonaliseerd leren\n      1. Adaptieve leeromgevingen\n      2. Individuele ondersteuning\nII. Uitdagingen en ethische overwegingen\n   A. Gegevensbescherming en privacy\n   B. Digitale kloof en toegankelijkheid",
    "document_placeholder": "Onderzoek_AI_Onderwijs.pdf",
    "article_placeholder": "https://www.nature.com/articles/s41586-023-06259-2",
    "study_program_placeholder": "Digitale educatie en mediapedagogiek",
    "study_subject_placeholder": "Digitale geesteswetenschappen",
    "interests_placeholder": "Duurzaamheid, Blockchain, Creatieve economie",
    "headline_placeholder": "AI-ondersteunde leerplatforms",
    "source_chat_placeholder": "Vat deze bron voor mij samen...",
    "random_text_placeholder": "De toekomst van werk staat voor een revolutionaire verandering door de integratie van kunstmatige intelligentie en automatiseringstechnologieën.\nTerwijl traditionele banen worden vervangen door robots en AI-systemen, ontstaan er gelijktijdig volledig nieuwe beroepsvelden en carrièremogelijkheden.\nHet vermogen tot continue bijscholing en aanpassing aan nieuwe technologieën wordt een sleutelcompetentie in de moderne arbeidswereld.\nRemote werk en flexibele werkmodellen winnen aan belang en veranderen fundamenteel hoe we samenwerking en productiviteit definiëren.\nBedrijven moeten zich steeds meer bezighouden met vragen over digitale ethiek, gegevensbescherming en de balans tussen efficiëntie en menselijke waardeschepping..."
  },
  "groups": {
    "research": "Onderzoek",
    "essay": "Essay",
    "misc_tools": "Overige hulpmiddelen"
  },
  "flows": {
    "summarize": {
      "headline": "Samenvatten",
      "description": "Wat zou je willen samenvatten?"
    },
    "titles": {
      "summarize_document": "Document",
      "summarize_text": "Tekst",
      "summarize_article": "Artikel",
      "summarize_source": "Bron"
    },
    "prefill": {
      "summarize_document": "Vat de inhoud van dit document voor mij samen."
    }
  },
  "messages": {
    "get_more_words": "Nu meer woorden krijgen",
    "contact_success": "Bedankt voor je bericht!",
    "error": "Er is iets misgegaan. Probeer het later opnieuw.",
    "updated": "{field} bijgewerkt",
    "failed_to_update": "Het bijwerken van \"{field}\" is mislukt, probeer het opnieuw",
    "generic_error": "Je verzoek is mislukt – probeer het later opnieuw of neem contact op met support 😔",
    "upload_error_generic": "We konden een van je bronnen niet verwerken – vervang die of gebruik onze automatische bronnen",
    "upload_error_url": "We konden de opgegeven URL niet verwerken – als het een PDF is, probeer het direct als bestand te uploaden",
    "upload_error_high_no_content": "We konden niet genoeg relevante info uit een van je bronnen halen – vervang die of gebruik onze automatische bronnen",
    "no_snippets_found_error": "Kon geen genoeg bronnen vinden voor de opgegeven gegevens – probeer het opnieuw met andere input",
    "account_deletion_error": "Je kunt je account niet verwijderen zolang je een actief abonnement hebt. Annuleer dat eerst."
  },
  "validation": {
    "required": "{_field_} is verplicht",
    "min": "{_field_} moet minimaal {length} tekens lang zijn",
    "max": "{_field_} mag niet langer zijn dan {length} tekens",
    "maxarray": "{_field_} heeft te veel elementen"
  },
  "domains": {
    "cancellation": {
      "headline": "Abonnement opzeggen",
      "description": "Wil je je abonnement echt opzeggen? Om welke reden wil je opzeggen?",
      "options": [
        {
          "text": "Werk voltooid",
          "value": "work_completed"
        },
        {
          "text": "Niet tevreden met het product",
          "value": "unsatisfied_with_product"
        },
        {
          "text": "Te duur",
          "value": "price_performance_issue"
        },
        {
          "text": "Technische problemen",
          "value": "technical_issues"
        },
        {
          "text": "Andere aanbieder gevonden",
          "value": "found_other_provider"
        },
        {
          "text": "Ik wist niet dat het een abonnement was",
          "value": "unaware_of_subscription"
        },
        {
          "text": "Anders",
          "value": "other"
        }
      ]
    },
    "try": {
      "headline": "Hesse Pro",
      "loading": "We activeren je proefaccount..."
    },
    "openai": {
      "status": {
        "unreliable": "We hebben momenteel een verhoogde serverbelasting. Er kunnen storingen optreden. Als er iets niet werkt, probeer het later opnieuw.",
        "working_on_fix": "Er kunnen momenteel storingen optreden. We werken al aan een oplossing. Probeer het later opnieuw."
      }
    },
    "ai_checker": {
      "hint": "AI-detectoren zijn hulpmiddelen die teksten controleren op AI-inhoud. Je kunt op de kaarten klikken om naar het bijbehorende hulpmiddel te gaan."
    },
    "cookie": {
      "headline": "Cookies 🍪",
      "text1": "Wanneer je op \"Alle cookies accepteren\" klikt, ga je akkoord met het opslaan van cookies op je apparaat om de sitenavigatie te verbeteren, het sitegebruik te analyseren en onze marketinginspanningen te ondersteunen.",
      "analytics": "Prestatie cookies",
      "analytics_text": "Deze cookies stellen ons in staat om het gebruikersgedrag op Hesse.ai anoniem te analyseren om de gebruikerservaring te optimaliseren.",
      "marketing_text": "Deze cookies kunnen door onze advertentiepartners via onze website worden ingesteld. Ze kunnen door die bedrijven worden gebruikt om een profiel van je interesses te maken en je relevante advertenties op andere sites te tonen.",
      "marketing": "Marketing cookies",
      "technical": "Functionele cookies",
      "technical_text": "Deze cookies zijn nodig om veilig en betrouwbaar gebruik te garanderen.",
      "consent": "Alle cookies accepteren",
      "save": "Voorkeuren opslaan",
      "decline": "Weigeren"
    },
    "write": {
      "save_changes": "Wijzigingen opslaan",
      "keep_writing": "Blijf schrijven"
    },
    "feedback": {
      "title": "Geef ons extra feedback",
      "description": "We proberen voortdurend onze resultaten te verbeteren. Beschrijf wat je zou willen dat er is veranderd."
    },
    "report": {
      "title": "Dit antwoord rapporteren?",
      "reason": "Reden voor rapportage",
      "description": "Rapporteer resultaten die kritieke of illegale inhoud bevatten.",
      "result_good": "Resultaat is nuttig",
      "result_bad": "Resultaat is niet nuttig"
    },
    "pricing": {
      "monthly_wordlimit": "{limit} woorden per maand",
      "increase_limit": "Limiet verhogen",
      "wordlimit_reached": "Je hebt je woordlimiet bereikt",
      "wordlimit_reached_description": "Het quotum voor deze maand is opgebruikt. Als je wilt doorgaan, moet je je limiet verhogen.",
      "wordlimit_nearly_reached": "Je woorden zijn bijna opgebruikt.",
      "get_more_words": "Meer woorden krijgen",
      "get_more_words_description": "Hoogwaardige teksten vereisen veel rekenkracht. Dat is duur.<br /> Maar we hebben onze pakketten zo betaalbaar mogelijk gemaakt.",
      "error_title": "De boeking is helaas niet gelukt.",
      "error_description": "Neem contact met ons op - We helpen direct.",
      "text1": "Hoeveel zijn 10.000 woorden?",
      "text2": "Dat waren 10.000 woorden",
      "referral_title": "Kun je nog niet beslissen?",
      "referral_title2": "Meer woorden nodig?",
      "referral_description": "Deel je link met vrienden. Je krijgt 1.000 gratis woorden voor elke nieuwe registratie via je link."
    },
    "survey": {
      "title": "Hoe beoordeel je Hesse.ai?",
      "suggestions": "Wat zou je veranderen?",
      "success_title": "Bedankt voor je feedback!",
      "success_text": "Je helpt ons Hesse.ai voortdurend te verbeteren",
      "abort": "niet beoordelen"
    },
    "cards_hint": {
      "title": "Flashcards zijn nu beschikbaar",
      "subtitle": "Automatisch <strong>flashcards</strong> maken van je <strong>college</strong>?",
      "cta": "Nu flashcards maken"
    },
    "share_modal": {
      "headline": "Hesse delen - gratis woorden krijgen"
    },
    "login_page": {
      "loading": "Je wordt ingelogd...",
      "error": "Inloggen is niet gelukt",
      "delayed": "Het inloggen duurt langer dan gewoonlijk.<br /> Controleer je internetverbinding en probeer het indien nodig opnieuw.",
      "try_again": "Opnieuw inloggen"
    },
    "sidebar": {
      "create_own_application": "Je eigen applicatie maken",
      "hesse_cards": "Hesse Kaarten 🃏",
      "all_applications": "Alle applicaties",
      "favourites": "Mijn favorieten"
    },
    "profile": {
      "title": "Profielinstellingen",
      "limit": "Limiet",
      "used_tokens": "Gebruikte tokens",
      "get_more_words": "Nu meer woorden krijgen",
      "no_subscription": "Je hebt nog geen abonnement.",
      "upgrade_now": "Nu upgraden",
      "manage_subscription": "Abonnement beheren",
      "delete_account": "Account verwijderen",
      "deleted": "Je account is verwijderd. Als je inlogt, wordt een nieuw account aangemaakt."
    },
    "contact": {
      "title": "Contact",
      "subtitle": "Neem contact met ons op"
    },
    "error_page": {
      "title404": "404 - Pagina niet gevonden",
      "title": "Er is een fout opgetreden",
      "text": "Help ons Hesse.ai te verbeteren.<br /> Beschrijf kort wat je deed vlak voordat deze pagina verscheen.",
      "cta": "Ga naar startpagina"
    },
    "success_page": {
      "loading": "laden...",
      "booking_success": "Je boeking is gelukt!",
      "booked_product": "Je hebt {productName} geboekt",
      "start_now": "Nu beginnen"
    }
  },
  "typewriter": {
    "writeEssay": [
      "Teksten worden gegenereerd...",
      "Teksten worden versleuteld...",
      "Plagiaatcontrole...",
      "AI-checker hulpmiddelen uitvoeren...",
      "Teksten niet meer traceerbaar ✔"
    ],
    "writeOutline": [
      "Teksten worden gegenereerd...",
      "Teksten worden versleuteld...",
      "Plagiaatcontrole...",
      "AI-checker hulpmiddelen uitvoeren...",
      "Teksten niet meer traceerbaar ✔"
    ],
    "writeIntroduction": [
      "Teksten worden gegenereerd...",
      "Teksten worden versleuteld...",
      "Plagiaatcontrole...",
      "AI-checker hulpmiddelen uitvoeren...",
      "Teksten niet meer traceerbaar ✔"
    ]
  },
  "loader": [
    "Je invoer evalueren",
    "Zout en peper toevoegen",
    "Pedro, Pedro, Pedro",
    "Toverstaf schudden",
    "Naar je tafel brengen"
  ],
  "features": {
    "find-sources": {
      "headline": "Bronnen vinden",
      "description": "Zoek naar academische bronnen die relevant kunnen zijn voor het onderwerp."
    },
    "write-outline": {
      "headline": "Schema maken",
      "description": "Maak een ruwe schets voor een onderzoekspaper onderwerp."
    },
    "write-chapter": {
      "headline": "Hoofdstuk schrijven",
      "description": "Schrijf een hoofdstuk voor een onderzoekspaper."
    },
    "write-essay": {
      "headline": "Essay schrijven",
      "description": "Schrijf een onderzoekspaper."
    },
    "source-qa": {
      "headline": "Bronnen-chat",
      "description": "Beantwoord vragen over een bron. Voeg een link toe naar een website of upload een bestand van je computer."
    },
    "proofreading": {
      "headline": "Proeflezen",
      "description": "Corrigeer een tekst."
    }
  }
}
